var exports = {
  "qS": "badge__Gkxv1c",
  "nf": "link__d7Iroi",
  "r4": "StackTitleLink__0knVjd",
};

module.exports = exports;
